import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface BusinessProfileResponse {
  data?: {
    icon_url?: string;
    icon?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface UpdateBusinessIconResponse {
  data?: {
    icon_url?: string;
    icon?: string;
    [key: string]: unknown;
  };
  message?: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  http = inject(HttpClient);
  baseURL = environment.apiUrl + '/api/v1';

  constructor() { }

  // Jobs apis

  login(payload: any) {
    return this.http.post(this.baseURL + '/login', payload);
  }

  register(payload: any) {
    return this.http.post(this.baseURL + '/register-business', payload)
  }

  verifyOTP(payload: any) {
    return this.http.post(this.baseURL + '/verify-otp', payload)
  }

  resendOTP(payload: any) {
    return this.http.post(this.baseURL + '/resend-otp', payload)
  }

  forgotPassword(payload: { email: string }) {
    return this.http.post(this.baseURL + '/forgot-password', payload)
  }

  resetPassword(payload: { token: string, new_password: string }) {
    return this.http.post(this.baseURL + '/reset-password', payload)
  }

  getRoles() {
    return this.http.get(this.baseURL + '/get-roles')
  }

  getUsers() {
    return this.http.get(this.baseURL + "/get-business-users")
  }

  getBusinessProfile() {
    return this.http.get<BusinessProfileResponse>(this.baseURL + '/get-business-info')
  }

  updateBusinessIcon(formData: any) {
    return this.http.put<UpdateBusinessIconResponse>(this.baseURL + '/update-business-info', formData)
  }

  addUser(payload: { name: string, email: string, role: string }) {
    return this.http.post(this.baseURL + '/add-user-to-business', payload)
  }

  getJobs() {
    return this.http.get(this.baseURL + '/get-jobs');
  }

  addJob(job: any) {
    return this.http.post(this.baseURL + '/add-job', job);
  }

  deleteJob(id: number) {
    return this.http.delete(this.baseURL + `/add-job/${id}`);
  }

  // Candidates apis

  addCandidate(job_id: any, candidate: any) {
    return this.http.post(this.baseURL + `/add-candidate/${job_id}`, candidate);
  }

  getCandidatesForReview(job_id: any) {
    return this.http.get(this.baseURL + `/public/get-candidates/${job_id}`);
  }

  getCandidates(job_id: any, fields?: any) {
    return this.http.get(this.baseURL + `/get-candidates/${job_id}`, {
      params: fields
    });
  }

  getCandidateById(job_id: any, id: any, fields?: any) {
    return this.http.get(this.baseURL + `/get-candidates/${job_id}/${id}`, {
      params: fields
    });
  }

  updateReviewStatus(candidate_id: any, status: 'pending' | 'rejected' | 'hold' | 'accepted' | 'analyzing' | 'pending review') {
    return this.http.put(this.baseURL + '/update-candidate-status/' + candidate_id, {
      status
    })
  }

  getAvailableCreds() {
    return this.http.get(this.baseURL + '/get-available-creds')
  }

  getBillingHistory() {
    return this.http.get(this.baseURL + '/get-transaction-history')
  }

  getTransactionDetails(session_id: string) {
    return this.http.get(this.baseURL + '/get-stripe-session-data', {
      params: { session_id }
    })
  }

  checkout(payload: { quantity: number }) {
    return this.http.post(this.baseURL + '/create-checkout-session', { ...payload })
  }
}
